// extracted by mini-css-extract-plugin
export default {"container":"UpdateLogo_container__0D2qE","logoContainer":"UpdateLogo_logoContainer__iZZvP","logo":"UpdateLogo_logo__AHDRv","buttonRow":"UpdateLogo_buttonRow__XOaKk"};